var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.isActive
    },
    on: {
      close: _vm.closeModal
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v("Delete autoresponder")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [_vm._v(" Are you sure you want to delete the autoresponder ")]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.closeModal
                }
              },
              [_vm._v(" Cancel ")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading
                },
                on: {
                  click: _vm.removeResponder
                }
              },
              [_vm._v(" Delete ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }